(() => {
  if (customElements.get('cabane-category-search')) return;
  class CategorySearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const input = this.querySelector('input');
      const button = this.querySelector('button');
      const params = new URL(location.href).searchParams;
      const group = window.CabaneCategoryNavigation?.groups[params.get('navigation')];
      const currentQuery = params.get('q') || '';
      const item = group?.items.find(candidate => {
        const url = new URL(candidate.url, location.origin);
        const query = url.searchParams.get('q');
        return url.pathname.endsWith('/search') && query && (query === currentQuery || currentQuery.startsWith('(' + query + ') AND '));
      });
      const groupQuery = group?.productQuery;
      const isGroupSearch = groupQuery && (currentQuery === groupQuery || currentQuery.startsWith('(' + groupQuery + ') AND '));
      const generalSearch = this.dataset.scope === 'all' && !isGroupSearch && !item;
      if (!input || (!item && !isGroupSearch && !generalSearch)) return;
      this.ready = true;
      const baseQuery = isGroupSearch ? groupQuery : item ? new URL(item.url, location.origin).searchParams.get('q') : '';
      input.value = generalSearch ? currentQuery : (params.get('category_search') || '');
      const submit = () => {
        const text = input.value.trim();
        const target = new URL(location.href);
        const query = text.split(/\s+/).filter(Boolean).map(word => 'title:"' + word.replace(/[\\"]/g, '\\$&') + '"').join(' AND ');
        if (generalSearch) {
          target.searchParams.set('q', window.CabaneDiscoverySearch?.normalizeQuery(text) || text);
          target.searchParams.set('type', 'product');
          for (const name of ['navigation', 'univers', 'category_search']) target.searchParams.delete(name);
        } else {
        target.searchParams.set('q', query ? '(' + baseQuery + ') AND (' + query + ')' : baseQuery);
        if (text) target.searchParams.set('category_search', text);
        else target.searchParams.delete('category_search');
        }
        target.searchParams.delete('page');
        location.assign(target.href);
      };
      input.addEventListener('input', event => event.stopPropagation());
      input.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        event.stopPropagation();
        submit();
      });
      input.addEventListener('search', () => { if (!input.value) submit(); });
      button?.addEventListener('click', submit);
    }
  }
  customElements.define('cabane-category-search', CategorySearch);
})();

